import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { pluck, map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { __rest } from 'tslib';
import * as i1$1 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, combineLatest } from 'rxjs';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as i6 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import moment from 'moment';
import * as i3 from 'base-job-description-library';
import { deleteDialogConfigurations } from 'base-job-description-library';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i4 from 'ngx-toastr';
import * as i5 from 'step-status-update-payload-service';
import * as i7 from 'cache-country-list';
import * as i8 from 'reference-library';
import * as i9 from 'primeng/dynamicdialog';
import * as i10 from 'app-services-library';
import * as i12 from 'base-lca-soc-code-library';
import * as i13 from '@angular/common';
import * as i14 from 'primeng/radiobutton';
import * as i15 from 'primeng/button';
import * as i16 from 'primeng/inputtext';
import * as i17 from 'primeng/divider';
import * as i18 from 'primeng/dropdown';
import * as i19 from 'primeng/api';
import * as i20 from 'primeng/tooltip';
import * as i21 from 'primeng/checkbox';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { JobDutiesLibraryModule } from 'job-duties-library';
import { H1bJobDescriptionModule } from 'h1b-job-description';
import { LastUpdateLibraryModule } from 'last-update-library';
import { HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { CustomQuestionnaireModule } from 'custom-questionnaire';

class JobDescriptionLcaWorkLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getLcaById(id) {
        return this.httpClient.get(`/dashboard/petitioner/lca/${id}`).pipe(pluck('data'), map((codes) => {
            return codes;
        }));
    }
}
JobDescriptionLcaWorkLibraryService.ɵfac = function JobDescriptionLcaWorkLibraryService_Factory(t) { return new (t || JobDescriptionLcaWorkLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
JobDescriptionLcaWorkLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: JobDescriptionLcaWorkLibraryService, factory: JobDescriptionLcaWorkLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLcaWorkLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function JobDescriptionLcaWorkLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "h5", 13);
    i0.ɵɵtext(2, "Identify Work Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDescriptionLcaWorkLibraryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "p-radioButton", 14);
    i0.ɵɵlistener("onClick", function JobDescriptionLcaWorkLibraryComponent_div_6_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.handleWorkLocationChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.disabledControls);
} }
function JobDescriptionLcaWorkLibraryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "p-radioButton", 16);
    i0.ɵɵlistener("onClick", function JobDescriptionLcaWorkLibraryComponent_div_7_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleWorkLocationChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_1_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_1_div_5_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.jobDescriptionForm.controls["clientName"].errors == null ? null : ctx_r11.jobDescriptionForm.controls["clientName"].errors.clientNameIsRequired);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "label", 23);
    i0.ɵɵtext(3, " Client Name ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 24);
    i0.ɵɵtemplate(5, JobDescriptionLcaWorkLibraryComponent_div_8_div_1_div_5_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r8.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.jobDescriptionForm.controls["clientName"].touched && ctx_r8.jobDescriptionForm.controls["clientName"].invalid);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_1_div_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r17 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" (+", item_r17.phoneCode, ") - ", item_r17.countryName, " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "p-dropdown", 44);
    i0.ɵɵtemplate(2, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_1_div_5_ng_template_2_Template, 3, 2, "ng-template", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", ctx_r15.countryList)("filter", false)("disabled", ctx_r15.disabledControls);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵelementStart(2, "label", 38);
    i0.ɵɵtext(3, " Phone Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵtemplate(5, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_1_div_5_Template, 3, 3, "div", 39);
    i0.ɵɵelementStart(6, "div", 40);
    i0.ɵɵelement(7, "input", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 37);
    i0.ɵɵelementStart(9, "label", 38);
    i0.ɵɵtext(10, " Email ID ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "input", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r13.isForeignCompany);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("readonly", ctx_r13.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r13.disabledControls);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 59);
    i0.ɵɵlistener("click", function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); const item_r18 = ctx_r30.$implicit; const addressIndex_r19 = ctx_r30.index; const ctx_r29 = i0.ɵɵnextContext(3); return ctx_r29.handleDeleteWorkLocation(item_r18, addressIndex_r19); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r20.disabledControls);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_9_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r32.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_9_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("addressLine1").errors == null ? null : item_r18.get("addressLine1").errors.required);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_14_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_14_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("addressLine2").errors == null ? null : item_r18.get("addressLine2").errors.required);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_15_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_15_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_15_div_4_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.controls["countryCode"].errors == null ? null : item_r18.controls["countryCode"].errors.required);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelementStart(1, "label", 23);
    i0.ɵɵtext(2, " Country ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 61);
    i0.ɵɵlistener("onChange", function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_15_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r41); const item_r18 = i0.ɵɵnextContext().$implicit; const ctx_r39 = i0.ɵɵnextContext(3); return ctx_r39.handleCountryChange($event.value, item_r18, true); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_15_div_4_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r23.countryList)("disabled", ctx_r23.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.controls["countryCode"].touched && item_r18.controls["countryCode"].invalid);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_16_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r44.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_16_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_16_div_4_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.controls["stateProvinceCode"].errors == null ? null : item_r18.controls["stateProvinceCode"].errors.required);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelementStart(1, "label", 23);
    i0.ɵɵtext(2, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 62);
    i0.ɵɵtemplate(4, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_16_div_4_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", item_r18.get("stateList").value)("disabled", ctx_r24.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.controls["stateProvinceCode"].touched && item_r18.controls["stateProvinceCode"].invalid);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_17_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r48.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_17_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_17_div_4_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.controls["stateProvinceName"].errors == null ? null : item_r18.controls["stateProvinceName"].errors.required);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵelementStart(1, "label", 38);
    i0.ɵɵtext(2, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 63);
    i0.ɵɵtemplate(4, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_17_div_4_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r25.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.controls["stateProvinceName"].touched && item_r18.controls["stateProvinceName"].invalid);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_22_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r51.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_22_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.getGlobalErrorMessages("INVALID_FORMAT"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_22_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵtemplate(2, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_22_span_2_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("city").errors == null ? null : item_r18.get("city").errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("city").errors == null ? null : item_r18.get("city").errors.pattern);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_27_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r54.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_27_span_1_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("postCode").errors == null ? null : item_r18.get("postCode").errors.required);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_p_divider_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 64);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 47);
    i0.ɵɵelementStart(2, "div", 48);
    i0.ɵɵtemplate(3, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_button_3_Template, 1, 1, "button", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 50);
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵelementStart(6, "label", 23);
    i0.ɵɵtext(7, " Address 1 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 51);
    i0.ɵɵtemplate(9, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_9_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 37);
    i0.ɵɵelementStart(11, "label", 38);
    i0.ɵɵtext(12, " Address 2 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 52);
    i0.ɵɵtemplate(14, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_14_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_15_Template, 5, 3, "div", 53);
    i0.ɵɵtemplate(16, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_16_Template, 5, 3, "div", 53);
    i0.ɵɵtemplate(17, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_17_Template, 5, 2, "div", 54);
    i0.ɵɵelementStart(18, "div", 55);
    i0.ɵɵelementStart(19, "label", 23);
    i0.ɵɵtext(20, " City ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 56);
    i0.ɵɵtemplate(22, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_22_Template, 3, 2, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 55);
    i0.ɵɵelementStart(24, "label", 23);
    i0.ɵɵtext(25, " Postal Code ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(26, "input", 57);
    i0.ɵɵtemplate(27, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_div_27_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(28, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_p_divider_28_Template, 1, 0, "p-divider", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const addressIndex_r19 = ctx.index;
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", addressIndex_r19);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", addressIndex_r19 != "0");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r14.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("addressLine1").touched && item_r18.get("addressLine1").invalid);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r14.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("addressLine2").touched && item_r18.get("addressLine2").invalid);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.isForeignCompany);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("stateList").value && item_r18.get("stateList").value.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("stateList").value && item_r18.get("stateList").value.length <= 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r14.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("city").touched && item_r18.get("city").invalid);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r14.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r18.get("postCode").touched && item_r18.get("postCode").invalid);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", addressIndex_r19 < ctx_r14.getAddressFormArray().length - 1);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_1_Template, 12, 3, "div", 29);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵtemplate(3, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_div_3_Template, 29, 14, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-divider", 32);
    i0.ɵɵelementStart(5, "div", 33);
    i0.ɵɵelementStart(6, "div", 34);
    i0.ɵɵelementStart(7, "button", 35);
    i0.ɵɵlistener("click", function JobDescriptionLcaWorkLibraryComponent_div_8_div_2_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(2); return ctx_r56.handleAddLocationClick(); });
    i0.ɵɵtext(8, "Add Locations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.inputData.visatype !== "L1A" && (ctx_r9.jobDescriptionForm.get("workLocationTypeCode").value === "TPARTY" || ctx_r9.jobDescriptionForm.get("workLocationTypeCode").value === "INHSECLT"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r9.getAddressFormArray());
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r9.disabledControls);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 72);
    i0.ɵɵelementStart(1, "div", 73);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Vendor Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 74);
    i0.ɵɵelementStart(6, "label");
    i0.ɵɵelementStart(7, "b");
    i0.ɵɵtext(8, "Vendor Point of Contact");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_6_button_17_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 85);
    i0.ɵɵlistener("click", function JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_6_button_17_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r65); const vendorIndex_r61 = i0.ɵɵnextContext().index; const ctx_r63 = i0.ɵɵnextContext(3); return ctx_r63.deleteVendor(vendorIndex_r61); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r62.disabledControls);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵelementStart(2, "div", 77);
    i0.ɵɵelementStart(3, "label", 38);
    i0.ɵɵtext(4, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "input", 78);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 79);
    i0.ɵɵelementStart(7, "label", 38);
    i0.ɵɵtext(8, "First Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 80);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 79);
    i0.ɵɵelementStart(11, "label", 38);
    i0.ɵɵtext(12, "Last Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 81);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 82);
    i0.ɵɵelement(15, "label", 38);
    i0.ɵɵelementStart(16, "button", 83);
    i0.ɵɵlistener("click", function JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_6_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(3); return ctx_r66.addVendor(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_6_button_17_Template, 1, 1, "button", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const vendorIndex_r61 = ctx.index;
    const ctx_r59 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", vendorIndex_r61);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r59.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r59.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r59.disabledControls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r59.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r59.jobDescriptionForm.get("vendorList").value.length > 1);
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelement(1, "p-divider", 66);
    i0.ɵɵelementStart(2, "div", 67);
    i0.ɵɵelementStart(3, "p-checkbox", 68);
    i0.ɵɵlistener("onChange", function JobDescriptionLcaWorkLibraryComponent_div_8_div_3_Template_p_checkbox_onChange_3_listener($event) { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(2); return ctx_r68.handleVendorChkboxChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 69);
    i0.ɵɵtemplate(5, JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_5_Template, 9, 0, "div", 70);
    i0.ɵɵtemplate(6, JobDescriptionLcaWorkLibraryComponent_div_8_div_3_div_6_Template, 18, 6, "div", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r10.jobDescriptionForm.get("isMiddleVendor").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.getVendorListFormArray());
} }
function JobDescriptionLcaWorkLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, JobDescriptionLcaWorkLibraryComponent_div_8_div_1_Template, 6, 2, "div", 18);
    i0.ɵɵtemplate(2, JobDescriptionLcaWorkLibraryComponent_div_8_div_2_Template, 9, 3, "div", 19);
    i0.ɵɵtemplate(3, JobDescriptionLcaWorkLibraryComponent_div_8_div_3_Template, 7, 2, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.inputData.visatype !== "L1A" && (ctx_r3.jobDescriptionForm.get("workLocationTypeCode").value === "TPARTY" || ctx_r3.jobDescriptionForm.get("workLocationTypeCode").value === "INHSECLT"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.jobDescriptionForm.get("workLocationTypeCode").value != null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.jobDescriptionForm.get("workLocationTypeCode").value === "TPARTY");
} }
class JobDescriptionLcaWorkLibraryComponent {
    constructor(jobDescriptionBuilder, store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, changeDetector, dialogService, customValidator, appServicesLibraryService, jobDescriptionLcaWorkLibraryService, apiServiceSOC) {
        this.jobDescriptionBuilder = jobDescriptionBuilder;
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.changeDetector = changeDetector;
        this.dialogService = dialogService;
        this.customValidator = customValidator;
        this.appServicesLibraryService = appServicesLibraryService;
        this.jobDescriptionLcaWorkLibraryService = jobDescriptionLcaWorkLibraryService;
        this.apiServiceSOC = apiServiceSOC;
        this.observableSubscription$ = new Subject();
        this.countryList = [];
        this.stateList = [];
        this.addressList = [];
        this.disabledControls = false;
    }
    ngOnInit() {
        if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
            this.isSimplify = true;
        }
        else {
            this.isSimplify = false;
        }
        this.inputData = this.primaryData;
        this.jobDescriptionForm = this.jobDescriptionBuilder.group({
            id: [null],
            address: this.jobDescriptionBuilder.array([]),
            workLocationTypeCode: [null, Validators.required],
            // caseId: [],
            // socCode1: [null],
            // socCode2: [null],
            // thisPastJob: [false],
            clientName: [null, this.clientNameRequired.bind(this)],
            clientEmail: [null],
            clientPhoneNo: [null],
            clientPhoneCountryCode: [this.isForeignCompany ? null : 'USA'],
            isMiddleVendor: [false],
            vendorList: this.jobDescriptionBuilder.array([])
        }, {
        // validator: this.customValidator.dateLessThan('startDate', 'endDate'),
        });
        // this.getWageUnitType();
        if (this.isForeignCompany) {
            this.cacheCountyService.getCountryWithoutUSA().subscribe(data => {
                if (data.length > 0) {
                    this.countryList = data;
                }
            });
        }
        else {
            this.getCountries();
        }
        if (this.isFromWizard) {
            this.getJobDescription();
            this.fileUploadConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
                getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
                // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
                // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
                // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
            });
        }
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            this.getJobDescription();
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
            this.stepDetails = data;
            this.fileUploadConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
                getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
                // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
                // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
                // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
            });
            this.toggleControlsStatus();
        });
    }
    createVendorDetailsItem(obj) {
        const vendorItem = this.jobDescriptionBuilder.group({
            vendorName: [obj['vendorName'] ? obj['vendorName'] : ''],
            vendorLastName: [obj['vendorLastName'] ? obj['vendorLastName'] : ''],
            vendorFirstName: [obj['vendorFirstName'] ? obj['vendorFirstName'] : ''],
        });
        this.jobDescriptionForm.controls['vendorList'].push(vendorItem);
    }
    addVendor() {
        this.createVendorDetailsItem({});
    }
    deleteVendor(vendorIndex) {
        this.jobDescriptionForm.controls['vendorList'].removeAt(vendorIndex);
    }
    createAddressItem(obj) {
        const addressGroupItem = this.jobDescriptionBuilder.group({
            id: [obj.id],
            addressLine1: [obj && obj.addressLine1 ? obj.addressLine1 : '', Validators.required],
            addressLine2: [obj && obj.addressLine2 ? obj.addressLine2 : ''],
            addressLine2NoType: [null],
            addressTypeCode: 'WORK',
            beneficiaryId: [null],
            countryCode: [
                this.isForeignCompany ? obj.countryCode ? obj.countryCode : null : 'USA',
                this.isForeignCompany ? [Validators.required] : []
            ],
            countryName: [null],
            doorNo: [null],
            locality: [null],
            state: [null],
            stateProvinceCode: [obj && obj.stateProvinceCode ? obj.stateProvinceCode : null],
            stateProvinceName: [obj && obj.stateProvinceName ? obj.stateProvinceName : null],
            stateList: [],
            streetNo: [null],
            city: [obj && obj.city ? obj.city : '', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
            postCode: [obj && obj.postCode ? obj.postCode : '', Validators.required],
            clientName: [obj && obj.clientName ? obj.clientName : null],
            clientEmail: [obj && obj.clientEmail ? obj.clientEmail : null],
            clientPhoneNo: [obj && obj.clientPhoneNo ? obj.clientPhoneNo : null],
            clientPhoneCode: [this.isForeignCompany ? null : 'USA'],
            type: [null],
            familyId: [null],
            companyId: [null],
            employeeId: [null],
            immigrationId: [null],
            workLocationId: [obj.workLocationId ? obj.workLocationId : 0],
            sequenceNo: [0]
        });
        if (this.jobDescriptionForm.get('workLocationTypeCode').value === 'TPARTY' ||
            this.jobDescriptionForm.get('workLocationTypeCode').value === 'INHSECLT') {
            addressGroupItem.get('clientName').setValidators(Validators.required);
        }
        if (this.jobDescriptionForm.get('workLocationTypeCode').value === 'INHSE') {
            addressGroupItem.get('clientName').clearValidators();
        }
        this.referenceLibraryService.getStatesFromStore(this.isForeignCompany ? obj.countryCode : 'USA')
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                addressGroupItem.controls['stateList'].setValue(states);
                if (states && states.length > 0) {
                    addressGroupItem.get('stateProvinceName').clearValidators();
                    addressGroupItem.get('stateProvinceCode').setValidators(Validators.required);
                }
                else {
                    addressGroupItem.get('stateProvinceName').setValidators(Validators.required);
                    addressGroupItem.get('stateProvinceCode').clearValidators();
                }
                this.jobDescriptionForm.controls['address'].push(addressGroupItem);
            }
            else {
                this.referenceLibraryService.getStatesFromApi(this.isForeignCompany ? obj.countryCode : 'USA')
                    .pipe(take(1))
                    .subscribe((data) => {
                    addressGroupItem.controls['stateList'].setValue(data);
                    if (data && data.length > 0) {
                        addressGroupItem.get('stateProvinceName').clearValidators();
                        addressGroupItem.get('stateProvinceCode').setValidators(Validators.required);
                    }
                    else {
                        addressGroupItem.get('stateProvinceName').setValidators(Validators.required);
                        addressGroupItem.get('stateProvinceCode').clearValidators();
                    }
                    this.jobDescriptionForm.controls['address'].push(addressGroupItem);
                });
            }
        });
    }
    getStateList(countryCode = 'USA', item) {
        this.referenceLibraryService.getStatesFromStore(countryCode)
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                item.controls['stateList'] = states;
            }
            else {
                this.referenceLibraryService.getStatesFromApi(countryCode)
                    .pipe(take(1))
                    .subscribe((data) => {
                    item.controls['stateList'] = data;
                });
            }
        });
    }
    handleCountryChange(countryCode, item, flag = false) {
        if (flag) {
            item.controls['stateProvinceCode'].setValue(null);
            item.controls['stateProvinceName'].setValue(null);
        }
        this.referenceLibraryService.getStatesFromStore(countryCode)
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                item.controls['stateList'].setValue(states);
                if (states && states.length > 0) {
                    item.get('stateProvinceName').clearValidators();
                    item.get('stateProvinceCode').setValidators(Validators.required);
                }
                else {
                    item.get('stateProvinceName').setValidators(Validators.required);
                    item.get('stateProvinceCode').clearValidators();
                }
                this.changeDetector.markForCheck();
            }
            else {
                this.referenceLibraryService.getStatesFromApi(countryCode)
                    .pipe(take(1))
                    .subscribe((data) => {
                    item.controls['stateList'].setValue(data);
                    if (data && data.length > 0) {
                        item.get('stateProvinceName').clearValidators();
                        item.get('stateProvinceCode').setValidators(Validators.required);
                    }
                    else {
                        item.get('stateProvinceName').setValidators(Validators.required);
                        item.get('stateProvinceCode').clearValidators();
                    }
                    this.changeDetector.markForCheck();
                });
            }
        });
    }
    afterViewInit() {
        this.jobDescriptionForm.valueChanges
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(() => {
            if (this.jobDescriptionForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getAddressFormArray() {
        return this.jobDescriptionForm.controls['address'].controls;
    }
    getVendorListFormArray() {
        return this.jobDescriptionForm.controls['vendorList'].controls;
    }
    buildDutyList(item) {
        const subJobDuty = [];
        if (item.subduty && item.subduty.length > 0) {
            item.subduty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        else if (item.subJobDuty && item.subJobDuty.length > 0) {
            item.subJobDuty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name,
            subJobDuty: this.jobDescriptionBuilder.array(subJobDuty)
        });
    }
    buildSubDutyList(item) {
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name
        });
    }
    // handleOnsaveJobRoleOrPopulateDuties(input: { selectedJobPosition: string, customPositionTitle: string, selectedJobPositionId: number }) {
    //   const overlppingReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, {
    //     ...deleteDialogConfigurations,
    //     data: {
    //       deleteMessage: 'Do you wish to populate duties & sub duties? This will override any existing duties'
    //     }
    //   });
    //   overlppingReconfirmDialogRef.onClose
    //     .pipe(takeUntil(this.observableSubscription$))
    //     .subscribe((response: boolean) => {
    //       if (response) {
    //         if (this.jobDescriptionForm.value && this.jobDescriptionForm.value.id) {
    //           this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType,
    //             this.inputData.caseId, this.jobDescriptionForm.value.id, 0)
    //             .pipe(take(1))
    //             .subscribe((IOSMappingResponse) => {
    //               if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
    //                 const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, {
    //                   ...deleteDialogConfigurations,
    //                   data: {
    //                     deleteMessage: 'Job duties cannot be populated as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
    //                   }
    //                 });
    //                 deleteReconfirmDialogRef.onClose
    //                   .pipe(takeUntil(this.observableSubscription$))
    //                   .subscribe((deleteReconfirmResponse: boolean) => {
    //                     if (deleteReconfirmResponse) {
    //                       this.jobDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
    //                       this.populateJobDuties(input);
    //                     }
    //                   });
    //               } else {
    //                 this.populateJobDuties(input);
    //               }
    //             });
    //         } else {
    //           // if there is no position id exists. no need to check ios mapping exists
    //           this.populateJobDuties(input);
    //         }
    //       }
    //     });
    // }
    // populateJobDuties(input) {
    //   (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
    //   this.store.dispatch(new MarkDirtyFormAction({
    //     dirty: true
    //   }));
    //   this.apiService.getJobRolesDuties(this.inputData.companyId,
    //     input.selectedJobPositionId)
    //     .pipe(takeUntil(this.observableSubscription$))
    //     .subscribe((response: any) => {
    //       if (response && response.jobDuty && response.jobDuty.length > 0) {
    //         response.jobDuty.forEach(element => {
    //           element['id'] = null;
    //           if (element.subduty && element.subduty.length > 0) {
    //             element.subduty.forEach(subJobDuty => {
    //               subJobDuty['id'] = null;
    //             });
    //           }
    //           (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(element));
    //         });
    //       }
    //     });
    // }
    // handleAddUpdateDuty({ type, data, dutyIndex }) {
    //   if (type === 'ADD') {
    //     // If type is ADD then append the job duties to exisiting one
    //     (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(data));
    //     this.store.dispatch(new MarkDirtyFormAction({
    //       dirty: true
    //     }));
    //   }
    //   if (type === 'UPDATE') {
    //     // If type is UPDATE then update the job duties
    //     (this.jobDescriptionForm.controls['duties'] as FormArray).setControl(dutyIndex, this.buildDutyList(data));
    //     this.store.dispatch(new MarkDirtyFormAction({
    //       dirty: true
    //     }));
    //   }
    // }
    getJobDescription() {
        this.apiService.getJobDescription(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.isForeignCompany)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b;
            if (response.status === 200) {
                //this.loadFormValues(response.data);
                this.inputData.jsonInput = { jobCategory: (_a = response.data) === null || _a === void 0 ? void 0 : _a.jobCategory, jobRole: (_b = response.data) === null || _b === void 0 ? void 0 : _b.jobRole };
                this.apiService.getJobRoles(this.inputData.companyId).pipe(takeUntil(this.observableSubscription$))
                    .subscribe((responseJobRoles) => {
                    if (responseJobRoles && responseJobRoles.data && responseJobRoles.data.length > 0 &&
                        responseJobRoles.data.find(x => x.jobTitle === response.data['jobRole'])) {
                        // predefined job role is selected do nothing
                        response.data['otherJobPosition'] = '';
                    }
                    else {
                        // Other option is selected & set the other job position manually
                        response.data['otherJobPosition'] = response.data['jobRole'];
                        response.data['jobRole'] = 'Other';
                    }
                    this.loadFormValues(response.data);
                });
            }
            else {
                // is there is no position details
                this.jobDescriptionForm.reset();
                this.jobDescriptionForm.patchValue({
                    selectedRaiobtn: 0,
                    jobRole: null
                });
                this.jobDescriptionForm.markAsPristine();
                this.jobDescriptionForm.markAsUntouched();
                this.loadAddress([]);
                this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
            }
        });
    }
    handleWorkLocationChange() {
        this.jobDescriptionForm.get('clientName').setValue(null);
        this.jobDescriptionForm.get('clientPhoneNo').setValue(null);
        this.jobDescriptionForm.get('clientEmail').setValue(null);
        if (this.isFromWizard) {
            this.apiServiceSOC.getLcaSOCCodeSelection(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).subscribe((response) => {
                var _a;
                if (response) {
                    this.lcaCodeId = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.lcaCodeId;
                    if (this.lcaCodeId) {
                        // get the lca details.
                        this.jobDescriptionLcaWorkLibraryService.getLcaById(this.lcaCodeId).
                            subscribe((data) => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                            let phoneDetails = (_b = (_a = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _a === void 0 ? void 0 : _a.company) === null || _b === void 0 ? void 0 : _b.phoneContacts.find(x => x.type.code === "OFFC");
                            let addressDetails = (_d = (_c = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _c === void 0 ? void 0 : _c.company) === null || _d === void 0 ? void 0 : _d.address.find(x => x.type.code === "MAIL");
                            let emailDetails = (_f = (_e = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _e === void 0 ? void 0 : _e.company) === null || _f === void 0 ? void 0 : _f.emailContacts.find(x => x.type.code === "PRIM");
                            this.loadAddress([Object.assign(Object.assign({}, addressDetails), { clientName: (_h = (_g = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _g === void 0 ? void 0 : _g.company) === null || _h === void 0 ? void 0 : _h.companyName, clientPhoneCode: phoneDetails === null || phoneDetails === void 0 ? void 0 : phoneDetails.phoneNo, clientEmail: emailDetails === null || emailDetails === void 0 ? void 0 : emailDetails.email })]);
                            this.jobDescriptionForm.patchValue({
                                clientName: (_k = (_j = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _j === void 0 ? void 0 : _j.company) === null || _k === void 0 ? void 0 : _k.companyName,
                                clientPhoneNo: phoneDetails === null || phoneDetails === void 0 ? void 0 : phoneDetails.phoneNo,
                                clientEmail: emailDetails === null || emailDetails === void 0 ? void 0 : emailDetails.email,
                            });
                        });
                    }
                    else {
                        CustomErrorToastComponent.showErrorToast(this.toastr, 'Details are not auto populated due to missing lca');
                    }
                }
            });
        }
        else {
            this.loadAddress([]);
        }
    }
    // Load job Desc form with values
    loadFormValues(response) {
        response = Object.assign(Object.assign({}, response), { isMiddleVendor: response.vendorList && response.vendorList.length > 0 });
        this.jobDescriptionForm.reset(Object.assign(Object.assign({}, response), { selectedRaiobtn: 0, jobRole: null }));
        // this.loadDuties(response.duties);
        this.loadAddress(response.address);
        this.loadVendor(response.vendorList);
    }
    loadVendor(list) {
        this.jobDescriptionForm.controls['vendorList'].clear();
        if (list && list.length > 0) {
            list.forEach(element => {
                this.createVendorDetailsItem(element);
            });
        }
    }
    loadAddress(list) {
        this.jobDescriptionForm.controls['address'].clear();
        if (list && list.length > 0) {
            list.forEach(element => {
                this.createAddressItem(element);
            });
        }
        else {
            this.createAddressItem({ id: null });
        }
    }
    // loadDuties(list) {
    //   (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
    //   list.forEach(element => {
    //     (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(element));
    //   });
    // }
    handleVendorChkboxChange(input) {
        if (input.checked) {
            this.createVendorDetailsItem({});
        }
        else {
            this.jobDescriptionForm.controls['vendorList'].clear();
        }
    }
    getCountries() {
        this.cacheCountyService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
        this.cacheCountyService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.listCountries.length > 0) {
                this.countryList = data.listCountries;
            }
        });
    }
    // getWageUnitType() {
    //   this.referenceLibraryService.getReferenceData('PAYTYP')
    //     .pipe(takeUntil(this.observableSubscription$))
    //     .subscribe((response: ReferenceLibrary[]) => {
    //       this.wageUnitType = response;
    //     });
    // }
    // handleDeleteAllDuties() {
    //   if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
    //     // api call to check whether ios is mapped or not
    //     const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
    //     deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
    //       if (response) {
    //         // if duty has id and user tries to delete it
    //         this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType,
    //           this.inputData.caseId, this.jobDescriptionForm.value.id, 0)
    //           .pipe(takeUntil(this.observableSubscription$))
    //           .subscribe((IOSMappingResponse) => {
    //             if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
    //               this.handleReconfirmDuty();
    //             }
    //             else {
    //               (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
    //               this.store.dispatch(new MarkDirtyFormAction({
    //                 dirty: true
    //               }));
    //             }
    //           });
    //       }
    //     });
    //   }
    //   else {
    //     (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
    //     this.store.dispatch(new MarkDirtyFormAction({
    //       dirty: true
    //     }));
    //   }
    // }
    // handleReconfirmDuty(dutyIndex: number = null) {
    //   const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, {
    //     ...deleteDialogConfigurations,
    //     data: {
    //       deleteMessage: 'Job duties cannot be deleted as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
    //     }
    //   });
    //   deleteReconfirmDialogRef.onClose
    //     .pipe(takeUntil(this.observableSubscription$))
    //     .subscribe((response: boolean) => {
    //       if (response) {
    //         this.jobDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
    //         if (dutyIndex) {
    //           (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(dutyIndex);
    //         }
    //         else {
    //           (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
    //         }
    //         this.store.dispatch(new MarkDirtyFormAction({
    //           dirty: true
    //         }));
    //       }
    //     });
    // }
    // handleDutyDelete(input: { duty: any, dutyIndex: number }) {
    //   if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
    //     // api call to check whether ios is mapped or not
    //     const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
    //     deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
    //       if (response) {
    //         if (input.duty['id']) {
    //           // if duty has id and user tries to delete it
    //           this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType,
    //             this.inputData.caseId, this.jobDescriptionForm.value.id,
    //             this.jobDescriptionForm.value.duties[input.dutyIndex].id)
    //             .pipe(takeUntil(this.observableSubscription$))
    //             .subscribe((IOSMappingResponse) => {
    //               if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
    //                 this.handleReconfirmDuty(input.dutyIndex);
    //               }
    //               else {
    //                 (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(input.dutyIndex);
    //                 this.store.dispatch(new MarkDirtyFormAction({
    //                   dirty: true
    //                 }));
    //               }
    //             });
    //         }
    //         else {
    //           // direct delete after confirmation without IOS mapping check
    //           (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(input.dutyIndex);
    //           this.store.dispatch(new MarkDirtyFormAction({
    //             dirty: true
    //           }));
    //         }
    //       }
    //     });
    //   }
    //   else {
    //     (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(input.dutyIndex);
    //     this.store.dispatch(new MarkDirtyFormAction({
    //       dirty: true
    //     }));
    //   }
    // }
    // handleSubDutyDelete(input: { dutyIndex, subJobDutyIndex }) {
    //   if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
    //     // api call to check whether ios is mapped or not
    //     const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
    //     deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
    //       if (response) {
    //         ((this.jobDescriptionForm.controls['duties'] as FormArray)
    //           .controls[input.dutyIndex] as FormArray)
    //           .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
    //         this.store.dispatch(new MarkDirtyFormAction({
    //           dirty: true
    //         }));
    //       }
    //     });
    //   }
    //   else {
    //     ((this.jobDescriptionForm.controls['duties'] as FormArray)
    //       .controls[input.dutyIndex] as FormArray)
    //       .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
    //     this.store.dispatch(new MarkDirtyFormAction({
    //       dirty: true
    //     }));
    //   }
    // }
    postJobDescription() {
        const intermediateObj = Object.assign({}, this.jobDescriptionForm.value);
        intermediateObj.address.forEach((element) => {
            delete element['stateList'];
        });
        const _a = Object.assign(Object.assign({}, intermediateObj), { startDate: this.jobDescriptionForm.value.startDate ? moment(this.jobDescriptionForm.value.startDate).format('YYYY-MM-DD') : null, endDate: this.jobDescriptionForm.value.endDate ? moment(this.jobDescriptionForm.value.endDate).format('YYYY-MM-DD') : null, selectedRaiobtn: intermediateObj.selectedRaiobtn, jobRole: intermediateObj.jobRole && intermediateObj.jobRole === 'Other' ? intermediateObj.otherJobPosition : intermediateObj.jobRole }), { selectedRaiobtn } = _a, payload = __rest(_a, ["selectedRaiobtn"]);
        const APIs = [
            this.apiService.postWorkJobDescription(payload, this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
        ];
        if (selectedRaiobtn === 1) {
            const selectJobRole = JSON.parse(sessionStorage.getItem('selectedJobRole'));
            const jobDuty = this.jobDescriptionForm.value.duties ?
                this.jobDescriptionForm.value.duties.map(x => {
                    return {
                        dutyId: x.id ? x.id : 0,
                        duty: x.name,
                        subduty: x.subJobDuty && x.subJobDuty.length > 0 ?
                            x.subJobDuty.map(y => {
                                return {
                                    dutyId: y.id ? y.id : 0,
                                    duty: y.name,
                                };
                            }) : []
                    };
                }) : [];
            const jobRole = {
                id: selectJobRole.id,
                jobDuty,
                jobRoleName: selectJobRole.jobTitle === 'Other' ? this.jobDescriptionForm.value.otherJobPosition : selectJobRole.jobTitle,
                requestFlag: 'updatemasterdata'
            };
            APIs.push(this.apiService.saveJobRole(this.inputData.companyId, this.jobDescriptionForm.value.selectedCategory.id, jobRole));
        }
        combineLatest(APIs)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            // this.saveMasterDataDuty();
            if (response[0] && response[0].status === 200) {
                this.toastr.success(response[0].message, 'Success');
                if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                    this.updateStepStatus('INPROGRESS');
                }
                else {
                    this.getJobDescription();
                }
            }
            if (selectedRaiobtn === 1 && response[1] && response[1].status === 200) {
                this.toastr.success(response[1]['message'], 'Success');
            }
        });
    }
    getSocCode() {
        this.titleSoc = '';
        this.apiService.ongetSOCCode(this.jobDescriptionForm.value.socCode)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(data => {
            if (data === null) {
                this.titleSoc = 'No SOC occupation title found';
                this.jobDescriptionForm.patchValue({
                    socTitle: null,
                });
            }
            else {
                // this.socTitle = data.title;
                this.titleSoc = '';
                this.jobDescriptionForm.patchValue({
                    socTitle: data.title,
                });
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    // Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // console.log('toggleControlsStatus ::', this.disabledControls);
        this.fileUploadConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
            postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
            deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
            getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
            // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
            // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
            // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleCancel() {
        this.getJobDescription();
    }
    handleAddLocationClick() {
        this.createAddressItem({ id: 0 });
    }
    handleDeleteWorkLocation(input, index) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
        deleteDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                if (input.value && input.value.workLocationId) {
                    this.apiService.deleteWorkLocation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, input.value.workLocationId)
                        .pipe(takeUntil(this.observableSubscription$))
                        .subscribe((response) => {
                        if (response) {
                            this.toastr.success(response.message, 'Success');
                            this.jobDescriptionForm.controls['address'].removeAt(index);
                            if (this.jobDescriptionForm.controls['address'].length <= 0) {
                                this.handleAddLocationClick();
                            }
                        }
                    });
                }
                else {
                    this.jobDescriptionForm.controls['address'].removeAt(index);
                    this.toastr.success('Deleted Successfully', 'Success');
                    if (this.jobDescriptionForm.controls['address'].length <= 0) {
                        this.handleAddLocationClick();
                    }
                }
            }
        });
    }
    onWageUnitChange(event) {
        switch (event.value) {
            case 'HOUR':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(2080 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'WEEK':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(52 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'BIWEEK':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(26 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'MONTH':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(12 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'YEAR':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
        }
    }
    clientNameRequired(control) {
        if (this.jobDescriptionForm &&
            (this.jobDescriptionForm.value.workLocationTypeCode && ['TPARTY', 'INHSECLT'].includes(this.jobDescriptionForm.value.workLocationTypeCode)) &&
            !control.value) {
            return { clientNameIsRequired: true };
        }
        return null;
    }
    onDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
JobDescriptionLcaWorkLibraryComponent.ɵfac = function JobDescriptionLcaWorkLibraryComponent_Factory(t) { return new (t || JobDescriptionLcaWorkLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.APIJobDescription), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i6.DirtyFormGuard), i0.ɵɵdirectiveInject(i7.CacheCountryListService), i0.ɵɵdirectiveInject(i8.ReferenceLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i9.DialogService), i0.ɵɵdirectiveInject(i3.DateValidators), i0.ɵɵdirectiveInject(i10.AppServicesLibraryService), i0.ɵɵdirectiveInject(JobDescriptionLcaWorkLibraryService), i0.ɵɵdirectiveInject(i12.APILCASOCCode)); };
JobDescriptionLcaWorkLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: JobDescriptionLcaWorkLibraryComponent, selectors: [["job-description-lca-work-library"]], inputs: { isForeignCompany: "isForeignCompany", primaryData: "primaryData", deleteAllDutie: "deleteAllDutie", addUpdateDuty: "addUpdateDuty", deleteDuty: "deleteDuty", deleteSubDuty: "deleteSubDuty", parentForm: "parentForm", isFromWizard: "isFromWizard" }, decls: 13, vars: 9, consts: [[3, "formGroup", "ngSubmit"], [1, "main-body"], ["class", "row col-md-12 mb-3", 4, "ngIf"], [1, "row", "col-md-12", "mb-3"], [1, "col-3", "pl-0"], ["name", "workLocationTypeCode", "styleClass", "radio-style", "formControlName", "workLocationTypeCode", "value", "INHSE", "label", "In-House", 1, "p-col", 3, "disabled", "onClick"], ["class", "col-3 pl-0", 4, "ngIf"], ["class", "col-6 pl-0", 4, "ngIf"], ["class", "row col-md-12 pl-0", 4, "ngIf"], [1, "row"], [1, "col-md-9"], [1, "col-md-3", "alignRight"], ["pButton", "", "type", "submit", "title", "Save", 3, "label", "ngClass", "disabled"], [1, "sub-title"], ["name", "workLocationTypeCode", "formControlName", "workLocationTypeCode", "value", "TPARTY", "label", "Third Party Site", 3, "disabled", "onClick"], [1, "col-6", "pl-0"], ["name", "workLocationTypeCode", "formControlName", "workLocationTypeCode", "value", "INHSECLT", "label", "Third Party Project Developed In-House", 3, "disabled", "onClick"], [1, "row", "col-md-12", "pl-0"], ["class", "row w-100 mb-3", 4, "ngIf"], ["class", "row col-md-12 pl-0 ml-0", 4, "ngIf"], ["class", "row col-md-12 pl-0 pb-2", 4, "ngIf"], [1, "row", "w-100", "mb-3"], [1, "col-md-6", "form-group", "input-disabled"], [1, "label-cls", "required"], ["id", "clientName", "formControlName", "clientName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [4, "ngIf"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], [1, "row", "col-md-12", "pl-0", "ml-0"], ["class", "row col-md-12 pl-0 mb-3", 4, "ngIf"], ["formArrayName", "address", 1, "row", "mb-3"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "row", "w-100"], [1, "row", "col-md-12", "save-location"], [1, "row", "col-md-12", "pl-0", "save-location"], ["type", "button", "pButton", "", 1, "mt-1", "p-button-outlined", 3, "disabled", "click"], [1, "row", "col-md-12", "pl-0", "mb-3"], [1, "col-md-6", "input-disabled"], [1, "label-cls"], ["class", "col-md-4 pl-0 pr-0 processing-dropdown", 4, "ngIf"], [1, "col-md-8", "px-0", "input-disabled"], ["type", "text", "placeholder", "Phone Number", "formControlName", "clientPhoneNo", "pInputText", "", "maxlength", "10", "pattern", "\\d{1,10}", 1, "im-input", "mw-100", 3, "readonly"], ["id", "clientEmail", "formControlName", "clientEmail", "pInputText", "", "type", "email", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-4", "pl-0", "pr-0", "processing-dropdown"], ["formControlName", "clientPhoneCode", "optionLabel", "phoneCode", "optionValue", "countryCode", "placeholder", "Select CountryCode", 3, "options", "filter", "disabled"], ["pTemplate", "item"], [1, "p-d-flex", "p-ai-center"], [1, "row", "w-100", 3, "formGroupName"], [1, "col-md-12", "d-flex", "justify-content-end"], ["pButton", "", "pRipple", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", "class", "pull-right p-button-rounded p-button-text", 3, "disabled", "click", 4, "ngIf"], [1, "row", "w-100", "mb-0"], ["id", "addressLine1", "formControlName", "addressLine1", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "addressLine2", "formControlName", "addressLine2", "pInputText", "", "type", "text", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["class", "col-md-3 form-group processing-dropdown", 4, "ngIf"], ["class", "col-md-3 input-disabled", 4, "ngIf"], [1, "col-md-3", "input-disabled"], ["id", "city", "formControlName", "city", "pInputText", "", "type", "text", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "postCode", "formControlName", "postCode", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["class", "mb-3 w-100", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "pull-right", "p-button-rounded", "p-button-text", 3, "disabled", "click"], [1, "col-md-3", "form-group", "processing-dropdown"], ["appendTo", "body", "id", "countryCode", "formControlName", "countryCode", "name", "country", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "select", 3, "options", "disabled", "onChange"], ["appendTo", "body", "id", "stateProvinceCode", "formControlName", "stateProvinceCode", "name", "country", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "select", 3, "options", "disabled"], ["id", "stateProvinceName", "formControlName", "stateProvinceName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "mb-3", "w-100"], [1, "row", "col-md-12", "pl-0", "pb-2"], [1, "row", "col-md-12", "pl-0", "pr-0", "pb-2"], [1, "row", "col-md-12", "pb-2"], ["label", "Is there a middle vendor", "value", "isMiddleVendor", "formControlName", "isMiddleVendor", "binary", "true", 3, "onChange"], ["formArrayName", "vendorList", 1, "row", "mb-3"], ["class", "row col-md-12  mt-4", 4, "ngIf"], ["class", "row col-md-12", 4, "ngFor", "ngForOf"], [1, "row", "col-md-12", "mt-4"], [1, "col-md-4", "pl-0"], [1, "col-md"], [1, "row", "col-md-12"], [1, "row", "col-md-12", "p-0", 3, "formGroupName"], [1, "col-md-3", "pl-0"], ["formControlName", "vendorName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-3"], ["formControlName", "vendorLastName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["formControlName", "vendorFirstName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-3", "mt-4"], ["pButton", "", "type", "button", "icon", "pi pi-plus", "title", "Add Vendor", "pTooltip", "Add Vendor", 1, "p-button-raised", "p-button-rounded", 2, "margin-right", "20px", 3, "disabled", "click"], ["pButton", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", "class", "p-button-raised p-button-rounded", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-raised", "p-button-rounded", 3, "disabled", "click"]], template: function JobDescriptionLcaWorkLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵlistener("ngSubmit", function JobDescriptionLcaWorkLibraryComponent_Template_form_ngSubmit_0_listener() { return ctx.postJobDescription(); });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, JobDescriptionLcaWorkLibraryComponent_div_2_Template, 3, 0, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "p-radioButton", 5);
        i0.ɵɵlistener("onClick", function JobDescriptionLcaWorkLibraryComponent_Template_p_radioButton_onClick_5_listener() { return ctx.handleWorkLocationChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, JobDescriptionLcaWorkLibraryComponent_div_6_Template, 2, 1, "div", 6);
        i0.ɵɵtemplate(7, JobDescriptionLcaWorkLibraryComponent_div_7_Template, 2, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, JobDescriptionLcaWorkLibraryComponent_div_8_Template, 4, 3, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵelement(10, "div", 10);
        i0.ɵɵelementStart(11, "div", 11);
        i0.ɵɵelement(12, "button", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.jobDescriptionForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isSimplify);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.visatype !== "L1A");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.visatype === "H1-B" || ctx.inputData.layoutCode === "H1_B_POSITION_DETAIL");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobDescriptionForm.get("workLocationTypeCode").value !== null);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("label", ctx.isFromWizard ? "Save" : "Save & Continue");
        i0.ɵɵproperty("ngClass", ctx.jobDescriptionForm.invalid || ctx.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx.jobDescriptionForm.invalid || ctx.disabledControls);
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i13.NgIf, i14.RadioButton, i1$1.NgControlStatus, i1$1.FormControlName, i15.ButtonDirective, i13.NgClass, i1$1.DefaultValueAccessor, i16.InputText, i1$1.FormArrayName, i13.NgForOf, i17.Divider, i1$1.MaxLengthValidator, i1$1.PatternValidator, i18.Dropdown, i19.PrimeTemplate, i1$1.FormGroupName, i20.Tooltip, i21.Checkbox], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLcaWorkLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'job-description-lca-work-library',
                templateUrl: 'job-description-lca-work-library.component.html',
                styles: []
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.Store }, { type: i3.APIJobDescription }, { type: i4.ToastrService }, { type: i5.StepStatusUpdatePayloadService }, { type: i6.DirtyFormGuard }, { type: i7.CacheCountryListService }, { type: i8.ReferenceLibraryService }, { type: i0.ChangeDetectorRef }, { type: i9.DialogService }, { type: i3.DateValidators }, { type: i10.AppServicesLibraryService }, { type: JobDescriptionLcaWorkLibraryService }, { type: i12.APILCASOCCode }]; }, { isForeignCompany: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], deleteAllDutie: [{
            type: Input
        }], addUpdateDuty: [{
            type: Input
        }], deleteDuty: [{
            type: Input
        }], deleteSubDuty: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], isFromWizard: [{
            type: Input
        }] }); })();

class JobDescriptionLcaWorkLibraryModule {
}
JobDescriptionLcaWorkLibraryModule.ɵfac = function JobDescriptionLcaWorkLibraryModule_Factory(t) { return new (t || JobDescriptionLcaWorkLibraryModule)(); };
JobDescriptionLcaWorkLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: JobDescriptionLcaWorkLibraryModule });
JobDescriptionLcaWorkLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            StepStatusUpdateComponentLibraryModule,
            JobDutiesLibraryModule,
            CustomQuestionnaireModule,
            FileUploadLibraryModule,
            H1bJobDescriptionModule,
            LastUpdateLibraryModule,
            HelpVideoOverlayLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(JobDescriptionLcaWorkLibraryModule, { declarations: [JobDescriptionLcaWorkLibraryComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        StepStatusUpdateComponentLibraryModule,
        JobDutiesLibraryModule,
        CustomQuestionnaireModule,
        FileUploadLibraryModule,
        H1bJobDescriptionModule,
        LastUpdateLibraryModule,
        HelpVideoOverlayLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule], exports: [JobDescriptionLcaWorkLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLcaWorkLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [JobDescriptionLcaWorkLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    StepStatusUpdateComponentLibraryModule,
                    JobDutiesLibraryModule,
                    CustomQuestionnaireModule,
                    FileUploadLibraryModule,
                    H1bJobDescriptionModule,
                    LastUpdateLibraryModule,
                    HelpVideoOverlayLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule
                ],
                exports: [JobDescriptionLcaWorkLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of job-description-lca-work-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { JobDescriptionLcaWorkLibraryComponent, JobDescriptionLcaWorkLibraryModule, JobDescriptionLcaWorkLibraryService };
//# sourceMappingURL=job-description-lca-work-library.js.map
